export const environment = {
  production: true,
  groupName: "--",
  apiUrl: "https://tilmanagement-api.azure.chevron.com/api/v1",
  clientId: "28ebd4cd-bfd2-42e3-ac2c-13b15f2fc63a",
  tenantId: "fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
  groups: {
    TurbineRoleGroups:
      "app-rat-mod-devlopers,CPL IT Business System Support Team,cgp turbine ui users",
    RamRoleGroups:
      "app-rat-mod-devlopers,CPL IT Business System Support Team,CPEM RAM Planners",
    LetterUserRoleGroups:
      "app-rat-mod-devlopers,CPL IT Business System Support Team,cpem-technical-letter-viewers",
    LetterAdminRoleGroups:
      "app-rat-mod-devlopers,CPL IT Business System Support Team,cpem-technical-letter-admins",
  },
};
